import { defineComponent as _defineComponent } from 'vue'

import {onMounted} from "vue";
	import {useRouter} from 'vue-router';
	import FetchOptions from "../interfaces/FetchOptions";
	import {FetchData} from "../utils/FetchData";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutPage',
  setup(__props) {

	const router = useRouter();

	onMounted(async () => {
		if(localStorage.token == undefined)
			return;

		const options: FetchOptions = {
			method: 'POST'
		};

		const data = await FetchData("logout", options);
		if(!data.isError) {
			emitter.emit('unauthorized');
			router.replace('/login');
		}
	});

return (_ctx: any,_cache: any) => {
  return " Je bent uitgelogd. "
}
}

})